/* eslint-disable */
import React, { Component } from "react";
import { connect } from "react-redux";
import { format } from "date-fns";
import { Helmet } from "react-helmet";
import { GET_FORMPOST, GET_DETAILDATA } from "../../actions";
import { userID, showAlert, showPriceValue } from "../Settings/Settings";
var module = "purchaseorder/";
var moduleName = "Purchaseorder";
class Form extends Component {
  constructor(props) {
    super(props);
    var poID = this.props.match.params?.poID || "";
    console.log(this.props.match, "this.props.match");

    this.state = {
      userID: userID(),
      poID: poID,
      postdata: "",
      detaildata: [],
      pageloading: false,
    };
  }

  componentDidMount() {
    $("body").css("background", "#FFF");

    if (this.state.poID !== "") {
      var params = {
        params:
          "&userID=" + this.state.userID + "&detail_id=" + this.state.poID,
        url: module + "invoice",
      };
      this.setState({ pageloading: true });
      this.props.getDetailData(params);
    }
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.state.detaildata !== nextProps.detaildata &&
      nextProps.detaildata !== "" &&
      typeof nextProps.detaildata !== undefined &&
      typeof nextProps.detaildata !== "undefined" &&
      this.state.editID !== ""
    ) {
      if (nextProps.detaildata.length > 0) {
        this.setState({ detaildata: nextProps.detaildata }, function () {
          if (nextProps.detaildata[0].status === "ok") {
            var result = nextProps.detaildata[0].result;

            var clientupdatedata = {
              purchaseVoucherNumber: result?.purchaseVoucherNumber,
              customer: {
                value: result.customerID,
                customerID: result.customerID,
                vendorName: result.vendorName,
                vendorAddress: result.vendorAddress,
                customerContactPerson: result.customerContactPerson,
                vendorPhone: result.vendorPhone,
                vendorEmail: result.vendorEmail,
                vendorGSTNo: result.vendorGSTNo,
                vendorGSTCode: result.vendorGSTCode,
              },
              shipto: {
                value: result.customerID,
                customerID: result.customerID,
                customerName: result.customerName,
                customerAddress1: result.customerAddress1,
                customerAddress2: result.customerAddress2,
                customerPincode: result.customerPincode,
                customerState: result.customerState,
                customerBranch: result.customerBranch,
                customerContactPerson: result.customerContactPerson,
                customerMobile: result.customerMobile,
                customerEmail: result.customerEmail,
                customerGSTNo: result.customerGSTNo,
                customerGSTCode: result.customerGSTCode,
              },
              modeofPayment: result.modeofPayment,
              purchaseReferenceNumber: result.purchaseReferenceNumber,
              purchaseOtherReferences: result.purchaseOtherReferences,
              purchaseDispatchedThrough: result.purchaseDispatchedThrough,
              purchaseDestination: result.purchaseDestination,
              purchaseTermsofDelivery: result.purchaseTermsofDelivery,
              products: result.purchaseItem,
              purchaseSubtotal: result.purchaseSubtotal,
              purchaseAmount: result.purchaseAmount,
              totalAmountWord: result.totalAmountWord,
              purchaseGSTAmount: result.purchaseGSTAmount,
              purchaseGSTPercentage: result.purchaseGSTPercentage,
              saleBuyerOrderNo: result.saleBuyerOrderNo,
              totalItem: result.totalItem,
              purchaseDate:
                result.purchaseDate !== "" &&
                result.purchaseDate !== "0000-00-00"
                  ? format(new Date(result.purchaseDate), "dd MMM yyyy")
                  : "",
              saleTermsofDelivery: result.saleTermsofDelivery,
            };
            this.setState(
              {
                postdata: clientupdatedata,
                pageloading: false,
              },
              () => {
                setTimeout(() => {
                  window.print();
                  window.onfocus = function () {
                    window.close();
                  };
                }, 100);
              }
            );
          } else {
            this.setState({ pageloading: false }, () => {
              this.props.history.push("/" + module);
              showAlert("Error", "Invalid" + moduleName, "error");
            });
          }
        });
      }
    }
  }

  render() {
    var postdata = this.state.postdata;
    const vendorAddress = postdata?.customer?.vendorAddress ?? "";
    return (
      <div>
        {postdata !== "" && (
          <Helmet>
            <meta charSet="utf-8" />
            <title>ResMax Power Tech - Invoice No: {postdata?.purchaseVoucherNumber}</title>
          </Helmet>
        )}
        <div className="print-a4 container print-invoice">
          <div className="align-center">
            <h3>PURCHASE ORDER</h3>
          </div>
          <table className="parant-tbl">
            <tr>
              <td>
                <table>
                  <tr>
                    <td width="50%">
                      <table className="addres-tbl">
                        <tr>
                          <td>
                            <div style={{ marginLeft: "3px" }}>
                              Invoice To
                              <br />
                              <b>RESMAX POWER TECH</b>
                              <br />
                              #17, Ground Floor, 40 Feet Road, KGF Munireddy
                              Layout, Mahadevapura, Bangalore- 560048
                              <br />
                              Recepient ID (K2) - 2903608503
                              <br />
                              GSTIN/UIN : 29AAZFR4823M1Z6
                              <br />
                              State Name : Karnataka, Code :29
                              <br />
                              GSTIN/UIN: 29AAZFR4823M1Z6
                              <br />
                              E-Mail : resmax@resmax.in
                              <br />
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div style={{ marginLeft: "3px" }}>
                              Consignee (Ship to)
                              <br />
                              <b>{postdata?.shipto?.customerName}</b>
                              <br />
                              {postdata?.shipto?.customerAddress1},{" "}
                              {postdata?.shipto?.customerAddress2}{" "}
                              {postdata?.shipto?.customerBranch} -{" "}
                              
                              {postdata?.shipto?.customerPincode}
                              <br />
                              Ph No: {postdata?.shipto?.customerMobile}
                              <br />
                              GSTIN/UIN : {postdata?.shipto?.customerGSTNo}
                              <br />
                              State Name : {postdata?.shipto?.customerState},
                              Branch : {postdata?.shipto?.customerBranch},
                              Code : {postdata?.shipto?.customerGSTCode}
                              <br />
                              GSTIN/UIN : {postdata?.shipto?.customerGSTNo}
                              <br />
                              E-Mail : {postdata?.shipto?.customerEmail}
                              
                            </div>
                          </td>
                        </tr>
                        <tr className="no-border-bottom">
                          <td className="no-border-top">
                            <div style={{ marginLeft: "3px" }}>
                              Buyer (Bill to)
                              <br />
                              <b>{postdata?.customer?.vendorName}</b>
                              <br />
                              {postdata?.customer?.vendorAddress}
                              <br />
                              Ph No: {postdata?.customer?.vendorPhone}
                              <br />
                              GSTIN/UIN : {postdata?.customer?.vendorGSTNo}
                              <br />
                              Code : {postdata?.customer?.vendorGSTCode}
                            </div>
                          </td>
                        </tr>
                      </table>
                    </td>
                    <td width="50%" valign="top">
                      <table className="invoice-tbl">
                        <tr>
                          <td>
                            Voucher No.
                            <br />
                            <b>{postdata.purchaseVoucherNumber}</b>
                          </td>
                          <td className="no-border-top">
                            Dated
                            <br />
                            <b>{postdata.purchaseDate}</b>
                          </td>
                        </tr>
                        <tr>
                          <td></td>
                          <td>
                            Mode/Terms of Payment
                            <br />
                            <b>{postdata?.modeofPayment}</b>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            Reference No. & Date
                            <br />
                            <b>{postdata.purchaseReferenceNumber}</b>
                          </td>
                          <td>
                            Other References
                            <br />
                            <b>{postdata.purchaseOtherReferences}</b>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            Dispatched through
                            <br />
                            <b>{postdata.purchaseDispatchedThrough}</b>
                          </td>
                          <td>
                            Destination
                            <br />
                            <b>{postdata.purchaseDestination}</b>
                          </td>
                        </tr>
                        <tr>
                          <td colSpan={2} className="no-border-bottom">
                            Terms of Delivery
                            <br />
                            <b>{postdata.purchaseTermsofDelivery}</b>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                </table>
                <table className="invoice-item">
                  <thead>
                    <tr>
                      <th style={{ width: "2%" }} className="no-border-left">
                        SI No.
                      </th>
                      <th style={{ width: "57%" }}>Description of Goods</th>
                      <th style={{ width: "10%" }}>Due on</th>
                      <th style={{ width: "8%" }}>Quantity</th>
                      <th style={{ width: "10%" }}>Rate</th>
                      <th style={{ width: "5%" }}>per</th>
                      <th style={{ width: "10%" }} className="no-border-right">
                        Amount
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {postdata?.products &&
                      postdata?.products.length > 0 &&
                      postdata?.products.map((item, index) => {
                        return (
                          <tr key={index}>
                            <td valign="top" className="no-border-left">
                              {parseInt(index) + 1}
                            </td>
                            <td>
                              <b>{item.productName}</b>
                            </td>
                            <td valign="top">{postdata.purchaseDate}</td>
                            <td align="right" valign="top">
                              {item.itemQuantity} No
                            </td>
                            <td align="right" valign="top">
                              {item.itemPrice}
                            </td>
                            <td align="right" valign="top">
                              Nos
                            </td>
                            <td
                              align="right"
                              valign="top"
                              className="no-border-right"
                            >
                              {item.itemTotalPrice}
                            </td>
                          </tr>
                        );
                      })}
                    <tr>
                      <td valign="top" className="no-border-left"></td>
                      <td align="right"><br/><br/><br/>
                        <b>IGST Input @{postdata.purchaseGSTPercentage}%<br/><br/><br/></b>
                      </td>
                      <td valign="top"></td>
                      <td align="right" valign="top"></td>
                      <td align="right" valign="top"><br/><br/><br/>{postdata.purchaseGSTPercentage}</td>
                      <td align="right" valign="top"><br/><br/><br/>
                        %
                      </td>
                      <td align="right" valign="top" className="no-border-right"><br/><br/><br/>
                        {postdata.purchaseGSTAmount}
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td className="no-border-left"></td>
                      <td align="right">Total</td>
                      <td></td>
                      <td></td>
                      <td align="right">{postdata?.totalItem} No</td>
                      <td></td>
                      <td align="right" className="no-border-right">
                        {showPriceValue(postdata?.purchaseAmount)}
                      </td>
                    </tr>
                  </tfoot>
                </table>
                <table>
                  <tr>
                    <td valign="top">
                      Amount Chargeable (in words)
                      <br />
                      <strong>{postdata?.totalAmountWord}</strong>
                    </td>
                    <td align="right" valign="top">
                      E. & O.E
                      <br/><br/><br/><br/><br/>
                      <table className="signatory-tbl" >
                        <tr>
                          <td align="right">
                            for <strong>RESMAX POWER TECH</strong>
                          </td>
                        </tr>
                        <tr>
                          <td align="right">
                            <div style={{ marginTop: "30px" }}>
                              Authorised Signatory
                            </div>
                          </td>
                        </tr>
                      </table>

                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
          <div className="align-center">
            This is a Computer Generated Document
          </div>
        </div>
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    formpost: state.formpost,
    detaildata: state.detaildata,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getFormPost: (formPayload, postUrl, postType) => {
      dispatch({ type: GET_FORMPOST, formPayload, postUrl, postType });
    },
    getDetailData: (datas) => {
      dispatch({ type: GET_DETAILDATA, datas });
    },
  };
};

export default connect(mapStateTopProps, mapDispatchToProps)(Form);
